import type {FC} from 'react'
import {useHierarchyFilters} from '@hooks/useHierarchyFilters.ts'
import BasicHierarchyFiltersRow from './BasicHierarchyFiltersRow.tsx'

type Props = {
  vertical?: boolean
}

const BasicHierarchyFilterGroup: FC<Props> = ({vertical = false}) => {
  const {
    filterState,
    updateParam,
    searchHandlers,
    data: {productionAreas, lines, equipments},
    loading: {isFetchingAreas, isFetchingLines, isFetchingEquipments},
    selectedNames,
    paramKeys,
  } = useHierarchyFilters()

  return (
    <BasicHierarchyFiltersRow
      filterState={filterState}
      productionAreas={productionAreas}
      lines={lines}
      equipments={equipments}
      searchHandlers={searchHandlers}
      loading={{isFetchingAreas, isFetchingLines, isFetchingEquipments}}
      selectedNames={selectedNames}
      paramKeys={paramKeys}
      updateParam={updateParam}
      vertical={vertical}
    />
  )
}

export default BasicHierarchyFilterGroup
